/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { connect } from 'react-redux';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import ApiInformation from './ApiInformation'
import ApiRating from './ApiRating'
import ApiDocumentation from './ApiDocumentation'
import ApiTags from './ApiTags';
import { useStyles } from './styles';
import { ApiReducer, ApplicationState } from '../../../data/interfaces';
import ApiScopes from './ApiScopes';
import AvailableVersions from './AvailableVersions';
import Settings from '../../../conf/settings';

export interface ApiOverviewProps {
    organizationHandle: string;
    apiState: ApiReducer;
}

function ApiOverview({ organizationHandle, apiState }: ApiOverviewProps) {
    const classes = useStyles();
    const { loading, api } = apiState;

    return (
        <main className={classes.content}>
            <Container className={classes.container} classes={{ root: classes.componentPadding }}>
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={12} md={12} lg={8} data-testid="api-info-grid">
                        <ApiInformation organizationHandle={organizationHandle} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={4}>
                        <Grid item xs container direction="column" spacing={1}>
                            <Grid item data-testid="ratings-grid">
                                <ApiRating disableTryOut={loading} />
                            </Grid>
                            {!loading && api?.version && api.version.startsWith("v")
                                && Settings.intelligentRoutingFeatureEnabled && (
                                    <Grid item>
                                        <AvailableVersions />
                                    </Grid>
                                )
                            }
                            <Grid item data-testid="scope-grid">
                                <ApiScopes />
                            </Grid>
                            <Grid item data-testid="tags-grid">
                                <ApiTags />
                            </Grid>
                            <Grid item data-testid="documents-grid">
                                <ApiDocumentation organizationHandle={organizationHandle} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </main>
    )
}
const mapStateToProps = (state: ApplicationState) => {
  return {
    apiState: state.apiReducer,
  };
};

export default connect(mapStateToProps)(ApiOverview);
